import { render, staticRenderFns } from "./small-header.vue?vue&type=template&id=02c28d0e&scoped=true&"
import script from "./small-header.vue?vue&type=script&lang=js&"
export * from "./small-header.vue?vue&type=script&lang=js&"
import style0 from "./small-header.vue?vue&type=style&index=0&id=02c28d0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c28d0e",
  null
  
)

component.options.__file = "small-header.vue"
export default component.exports